export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7972.dc3ac6d2.jpg";